"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ROUND = void 0;
exports.ROUND = {
    alias: 'ARRED',
    description: 'Arredonda um número para um número especificado de dígitos',
    arg_names: ['numero', 'num_digitos'],
    args_description: [
        'O número que pretende arredondar',
        'Especifica o número de dígitos para o qual pretende arredondar o argumento núm',
    ],
};
